import React from 'react';
import { createUseStyles } from 'react-jss';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { UserState } from '../user/UserState';
import { IntroScreenState } from './IntroScreenState';
import { VideoBackground } from './VideoBackground';
import { CenteredMessageOverlay } from '../components/CenteredMessageOverlay';

const useStyles = createUseStyles({
    banner: {
        position: 'relative',
        top: 0,
        width: '100%',
        height: 300,
    }
});

export const HomePageBanner: React.FC = () => {

    const classes = useStyles();

    const userState = useInstance(UserState);
    useSubscription(() => userState);
    const name = userState.state.firstName || '';
    const welcomeMessage = (name ? `Welcome, ${name}` : 'Welcome');

    const introScreenState = useInstance(IntroScreenState);
    useSubscription(() => introScreenState);

    return (
        <div className={classes.banner}>
            <VideoBackground skipIncrement={introScreenState.isVisible()} />
            <CenteredMessageOverlay>{welcomeMessage}</CenteredMessageOverlay>
        </div>
    );
};
